import { storeToRefs } from 'pinia';

import type { IFShowModal, IFRemoveModal, IFEditUserData, IFEditTeamData, IFEditBusinessData, IFEditMailboxBusinessData, IFEditAlertData, EditAlertData } from '@/modules/shared/interfaces/Modal';
import { useModalStore } from '@/modules/shared/stores/modal';
import { useTableStore } from '@/modules/settings/stores/table';
import type { Iitems } from '@/modules/shared/interfaces/inputMultiple';
import type { IMetricAdjustmentsFront } from '@/modules/settings/interfaces/MetricAdjustments';
import { useAlertsStore } from '@/modules/explore/store/alerts';

const useModal = () => {
    const storeModal = useModalStore();

    const {
        showModalRemove,
        showModalAdd,
        showModalUpdateUser,
        showModalUpdateTeam,
        showModalUpdateAlert,
        showModalMailboxBusinessHours,
        showModalUpdateBusiness,
        showModalUpdateMetricAdjustments,
        showModalUpdateInternalDomains,
        openModal
    } = useModalStore();
    const { data, modalData, deleteData, editUserData, editTeamData, editAlertData, editBusinessData, editMailboxBusinessData, activeModal, hasCloseButton } = storeToRefs(storeModal);
    const { setSelectedItems } = useTableStore();
    const alertsStore = useAlertsStore();
    const { alerts } = storeToRefs(alertsStore);

    return {
        activeModal,
        data,
        modalData,
        deleteData,
        editUserData,
        editTeamData,
        editAlertData,
        editBusinessData,
        editMailboxBusinessData,
        openModal,
        removeModal: (data: IFRemoveModal) => {
            showModalRemove(data);
            setSelectedItems([]);
        },
        showModal: (data: IFShowModal, useCloseButton = true) => {
            showModalAdd(data);
            hasCloseButton.value = useCloseButton;
        },
        showModalUpdateUser: (data: IFEditUserData) => {
            showModalUpdateUser(data);
        },
        showModalUpdateTeam: (data: IFEditTeamData) => {
            showModalUpdateTeam(data);
        },
        showModalUpdateAlert: async (data: IFEditAlertData) => {
            showModalUpdateAlert({
                name: data.name,
                data: alerts.value.find((a) => a.id === data.data.id) as EditAlertData
            });
        },
        showModalMailboxBusinessHours: (data: IFEditMailboxBusinessData) => {
            showModalMailboxBusinessHours(data);
        },
        showModalUpdateBusiness: (data: IFEditBusinessData) => {
            showModalUpdateBusiness(data);
        },
        showModalUpdateMetricAdjustments: (data: { name: string; data: IMetricAdjustmentsFront[] }) => {
            showModalUpdateMetricAdjustments(data);
        },
        showModalUpdateInternalDomains: (data: { name: string; data: Iitems[] }) => {
            showModalUpdateInternalDomains(data);
        },
        hideModal: () => storeModal.hideModal()
    };
};

export default useModal;
